import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import Noty from 'noty';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { Modal, Form } from 'react-bootstrap';
import Button from '../ui/Button';
import Loader from '../ui/Loader';
import CloseIcon from '../Icons/CloseIcon';

class CategoryDialog extends Component {
  constructor(props) {
    super(props);

    this.envContext = props.isThesaurus ? 'thesaurusDialog' : 'categoryDialog';
    this.state = {
      isSubmitting: false,
      name: '',
      dialogTitle: `${this.envContext}.addHeader`,
      dialogSaveButtonLabel: `${this.envContext}.createButton`,
      isDelete: false,
      newName: '',
      isGlobal: this.props.selectedCategoryData && this.props.selectedCategoryData.isGlobal,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onDeleteCheck = this.onDeleteCheck.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isEdit !== this.props.isEdit || prevProps.editRequests !== this.props.editRequests
      || prevProps.isThesaurus !== this.props.isThesaurus ||
      prevProps.selectedCategoryData !== this.props.selectedCategoryData) {
      let isSubmitting = false;
      let name = '';
      let dialogTitle = `${this.envContext}.addHeader`;
      let dialogSaveButtonLabel = `${this.envContext}.createButton`;
      let isDelete = false;

      if (this.props.isThesaurus !== prevProps.isThesaurus) this.envContext = this.props.isThesaurus ? 'thesaurusDialog' : 'categoryDialog';
      // change default for edit existing category
      if (this.props.isEdit) {
        const existingRequest = this.props.editRequests.get(this.props.selectedCategoryData.id);
        isSubmitting = !!existingRequest;
        name = existingRequest ? existingRequest.get('categoryName') :
          this.props.selectedCategoryData.name;
        dialogTitle = `${this.envContext}.editHeader`;
        dialogSaveButtonLabel = `${this.envContext}.saveButton`;
        isDelete = false;
      } else if (this.props.selectedCategoryData && this.props.selectedCategoryData.isGlobal) {
        // Global Category Creation
        dialogTitle = 'navCategoryPanel.createGlobalCategoryBtn';
      } else if (this.props.selectedCategoryData) {
        // create category at non-root level
        name = this.props.selectedCategoryData.name;
        dialogTitle = `${this.envContext}.createChildHeader`;
        dialogSaveButtonLabel = `${this.envContext}.createButton`;
      }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isSubmitting,
        name,
        dialogTitle,
        dialogSaveButtonLabel,
        isDelete,
        newName: name,
        isGlobal: this.props.selectedCategoryData && this.props.selectedCategoryData.isGlobal,
      });
    }
  }

  onDeleteCheck() {
    this.setState({ isDelete: !this.state.isDelete });
  }

  onFormSubmit(e) {
    e.preventDefault();
    const data = this.props.selectedCategoryData || {};

    if (this.state.isDelete) {
      new Noty({
        theme: 'bootstrap-v4',
        type: 'info',
        text: this.props.intl.formatMessage({ id: `${this.envContext}.deleteInProgress` }),
        layout: 'center',
        closeWith: 'click',
        timeout: 4000,
      }).show();
      this.props.onDeleteSubmit(data.id);
    } else if (this.props.isEdit) {
      this.props.onEditSubmit(
        data.id, this.state.newName
      );
    } else if (this.state.isGlobal) {
      this.props.onCreateGlobalSubmit(this.state.newName, data.collectionID);
    } else if (data.collectionID && data.id === '0') {
      this.props.onCreateRootSubmit(this.state.newName, data.collectionID);
    } else {
      this.props.onCreateSubmit(
        data ? data.id : undefined,
        this.state.newName,
      );
    }

    // making the assumption that it will successfully submit so it seems speedier
    this.props.onCategoryDialogToggle(false);
  }

  render() {
    const {
      isCategoryDialogShown,
      onCategoryDialogToggle,
      intl,
      } = this.props;

    return (
      <div className="category-dialog">
        <Modal
          show={isCategoryDialogShown}
          onHide={() => onCategoryDialogToggle(false)}
          dialogClassName={classNames('category-dialog__overlay', {
            'category-dialog__overlay--edit': this.props.isEdit,
          })}
        >
          <CloseIcon
            width={32}
            height={32}
            onClick={() => onCategoryDialogToggle(false)}
            className="category-dialog__close-button"
          />

          <div className="category-dialog__form">
            <div className="category-dialog__form-header">
              {intl.formatMessage({ id: this.state.dialogTitle })}

              <div className="category-dialog__form-header-sub">
                {this.state.name}
              </div>
            </div>

            <Form onSubmit={this.onFormSubmit}>
              <Form.Group className="form-group category-dialog__form-name">
                <Form.Control
                  type="text"
                  disabled={this.state.isSubmitting}
                  onChange={e => this.setState({ newName: e.target.value })}
                  placeholder={intl.formatMessage({ id: `${this.envContext}.namePlaceholder` })}
                  value={this.state.newName}
                />
              </Form.Group>

              {
                this.props.isEdit ? (
                  <Form.Group className="category-dialog__delete">
                    <Form.Check
                      type='checkbox'
                      id="category-dialog__delete-checkbox"
                      onChange={this.onDeleteCheck}
                      checked={this.state.isDelete}
                      label={intl.formatMessage({ id: `${this.envContext}.deleteCheckbox` })}
                    />
                  </Form.Group>
                ) : null
              }

              {
                this.state.isDelete ?
                  <Button type="submit" variant="danger">
                    { intl.formatMessage({ id: `${this.envContext}.deleteButton` })}
                  </Button>
                  :
                  <Button primary type="submit" disabled={this.state.isSubmitting}>
                    {this.state.isSubmitting ? <Loader /> :
                      intl.formatMessage({ id:this.state.dialogSaveButtonLabel}) }
                  </Button>
              }
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

CategoryDialog.propTypes = {
  isCategoryDialogShown: PropTypes.bool,
  onCategoryDialogToggle: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  onCreateRootSubmit: PropTypes.func,
  onCreateGlobalSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  isEdit: PropTypes.bool,
  editRequests: PropTypes.instanceOf(Map),
  selectedCategoryData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    collectionID: PropTypes.string,
  }),
  isThesaurus: PropTypes.bool,
};

export default injectIntl(CategoryDialog);
